import { createAction } from '@reduxjs/toolkit';

export const routeChange = createAction('[Route] routeChange');
export const atEditRequest = createAction('[Route] atEditRequest');
export const atViewRequest = createAction('[Route] atViewRequest');
export const atViewRequests = createAction('[Route] atViewRequests');
export const atCreateRequest = createAction('[Route] atCreateRequest');
